/* ============================================================
   Phoenix Phase Converters — AI Widget
   Amy (Sales) + Lisa (Support)
   Drop this <script> tag before </body> on any page
   ============================================================ */
(function() {
  'use strict';

  const AMY_AGENT_ID  = 'agent_c32ca19bc30e97c5f6f597e2ce';
  const LISA_AGENT_ID = 'agent_96c658053305980082dc03d0bd';
  const RETELL_KEY    = 'key_4a431a99b270e908167ff1f62afd';

  /* ── Styles ─────────────────────────────────────────────── */
  const css = `
  #ppc-widget-wrap * { box-sizing: border-box; margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
  #ppc-widget-wrap { position: fixed; bottom: 24px; right: 24px; z-index: 99999; display: flex; flex-direction: column; align-items: flex-end; gap: 10px; }

  /* Tooltip */
  #ppc-tooltip {
    background: rgba(8,10,20,0.95);
    border: 1px solid rgba(79,163,255,0.2);
    border-radius: 11px;
    padding: 8px 13px;
    display: flex; align-items: center; gap: 9px;
    white-space: nowrap;
    position: relative;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: opacity .3s, transform .3s;
    cursor: default;
  }
  #ppc-tooltip.hidden { opacity: 0; transform: translateY(6px); pointer-events: none; }
  #ppc-tooltip-arrow {
    position: absolute; bottom: -5px; right: 17px;
    width: 10px; height: 10px;
    background: rgba(8,10,20,0.95);
    border-right: 1px solid rgba(79,163,255,0.2);
    border-bottom: 1px solid rgba(79,163,255,0.2);
    transform: rotate(45deg);
  }
  .ppc-tip-orbs { display: flex; gap: 4px; align-items: center; }
  .ppc-tip-canvas { border-radius: 50%; display: block; }
  .ppc-tip-text strong { display: block; font-size: 12px; font-weight: 500; color: #fff; }
  .ppc-tip-text span { font-size: 11px; color: rgba(255,255,255,.4); }

  /* Launcher button */
  #ppc-launcher {
    width: 54px; height: 54px; border-radius: 50%;
    background: #050a14;
    border: 1px solid rgba(79,163,255,0.25);
    cursor: pointer; position: relative;
    display: flex; align-items: center; justify-content: center;
    transition: transform .2s;
    box-shadow: 0 0 24px rgba(79,163,255,0.15);
  }
  #ppc-launcher:hover { transform: scale(1.07); }
  #ppc-launcher canvas { position: absolute; inset: 0; width: 100%; height: 100%; border-radius: 50%; }
  .ppc-ring {
    position: absolute; inset: -4px; border-radius: 50%;
    border: 1px solid rgba(79,163,255,0.3);
    animation: ppc-ring 2.8s ease-out infinite;
    pointer-events: none;
  }
  .ppc-ring2 {
    position: absolute; inset: -4px; border-radius: 50%;
    border: .5px solid rgba(79,163,255,0.12);
    animation: ppc-ring 2.8s ease-out .9s infinite;
    pointer-events: none;
  }
  @keyframes ppc-ring { 0%{transform:scale(1);opacity:.9} 100%{transform:scale(1.75);opacity:0} }
  #ppc-online {
    position: absolute; bottom: 2px; right: 2px;
    width: 12px; height: 12px; border-radius: 50%;
    background: #2ECC71; border: 2px solid #fff;
    animation: ppc-pulse 2s infinite;
  }
  @keyframes ppc-pulse { 0%,100%{opacity:1} 50%{opacity:.4} }

  /* Panel */
  #ppc-panel {
    position: fixed; bottom: 90px; right: 24px;
    width: 300px;
    background: #07070f;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 18px;
    overflow: hidden;
    z-index: 99998;
    transition: opacity .3s, transform .3s;
    box-shadow: 0 20px 60px rgba(0,0,0,0.5);
  }
  #ppc-panel.hidden { opacity: 0; transform: translateY(12px); pointer-events: none; }

  /* Panel header */
  .ppc-panel-header {
    background: #0c0c1a;
    padding: 14px 16px 12px;
    display: flex; align-items: center; justify-content: space-between;
    border-bottom: 1px solid rgba(255,255,255,0.05);
  }
  .ppc-panel-title { font-size: 13px; font-weight: 500; color: #fff; }
  .ppc-panel-sub { font-size: 11px; color: rgba(255,255,255,.35); margin-top: 1px; }
  #ppc-close {
    width: 24px; height: 24px; border-radius: 50%;
    background: rgba(255,255,255,.07); border: none; cursor: pointer;
    color: rgba(255,255,255,.5); font-size: 14px; display: flex; align-items: center; justify-content: center;
    transition: background .15s;
  }
  #ppc-close:hover { background: rgba(255,255,255,.14); }

  /* Agent cards inside panel */
  .ppc-agents { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding: 14px; }
  .ppc-agent-card {
    background: #0c0c18;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 13px;
    padding: 14px 10px;
    display: flex; flex-direction: column; align-items: center; gap: 8px;
    cursor: pointer;
    transition: border-color .2s, background .2s;
  }
  .ppc-agent-card:hover { border-color: rgba(79,163,255,0.3); background: #10101f; }
  .ppc-agent-card.lisa:hover { border-color: rgba(166,107,255,0.3); }
  .ppc-agent-name { font-size: 13px; font-weight: 500; color: #fff; }
  .ppc-agent-role { font-size: 11px; color: rgba(255,255,255,.35); text-align: center; line-height: 1.3; }
  .ppc-agent-dot { width: 6px; height: 6px; border-radius: 50%; animation: ppc-pulse 2s infinite; }
  .ppc-agent-dot.amy { background: #4fa3ff; }
  .ppc-agent-dot.lisa { background: #a66bff; }

  /* Mode tabs */
  .ppc-tabs { display: flex; gap: 0; background: rgba(255,255,255,.04); border-radius: 8px; padding: 2px; margin: 0 14px 14px; }
  .ppc-tab {
    flex: 1; border: none; background: transparent; color: rgba(255,255,255,.35);
    font-size: 11px; padding: 5px 4px; border-radius: 7px; cursor: pointer;
    font-family: inherit; transition: all .2s; display: flex; align-items: center; justify-content: center; gap: 4px;
  }
  .ppc-tab svg { width: 12px; height: 12px; }
  .ppc-tab.active-amy { background: #4fa3ff; color: #020d1a; font-weight: 500; }
  .ppc-tab.active-lisa { background: #a66bff; color: #0d0520; font-weight: 500; }

  /* Chat area */
  .ppc-chat { padding: 0 14px 14px; display: flex; flex-direction: column; gap: 8px; min-height: 120px; }
  .ppc-bubble {
    max-width: 88%; padding: 8px 11px; border-radius: 12px;
    font-size: 12px; line-height: 1.55;
  }
  .ppc-bubble.agent-amy { background: rgba(79,163,255,0.1); border: 1px solid rgba(79,163,255,0.2); color: #a8d4ff; border-bottom-left-radius: 3px; align-self: flex-start; }
  .ppc-bubble.agent-lisa { background: rgba(166,107,255,0.1); border: 1px solid rgba(166,107,255,0.2); color: #cdb0ff; border-bottom-left-radius: 3px; align-self: flex-start; }
  .ppc-bubble.user { background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.08); color: rgba(255,255,255,.65); border-bottom-right-radius: 3px; align-self: flex-end; }
  .ppc-typing { display: flex; gap: 4px; align-items: center; padding: 9px 12px; border-radius: 12px; border-bottom-left-radius: 3px; align-self: flex-start; width: fit-content; }
  .ppc-typing.amy { background: rgba(79,163,255,.08); border: 1px solid rgba(79,163,255,.15); }
  .ppc-typing.lisa { background: rgba(166,107,255,.08); border: 1px solid rgba(166,107,255,.15); }
  .ppc-td { width: 6px; height: 6px; border-radius: 50%; animation: ppc-dot 1.4s infinite; }
  .ppc-td.amy { background: #4fa3ff; }
  .ppc-td.lisa { background: #a66bff; }
  .ppc-td:nth-child(2) { animation-delay: .18s; }
  .ppc-td:nth-child(3) { animation-delay: .36s; }
  @keyframes ppc-dot { 0%,60%,100%{transform:translateY(0);opacity:.35} 30%{transform:translateY(-5px);opacity:1} }

  /* Voice area */
  .ppc-voice { display: none; flex-direction: column; align-items: center; justify-content: center; gap: 12px; min-height: 120px; padding: 0 14px 14px; }
  .ppc-veq { display: flex; align-items: flex-end; gap: 3px; height: 32px; }
  .ppc-vb { width: 4px; border-radius: 2px; animation: ppc-veq .85s ease-in-out infinite alternate; }
  .ppc-vb.amy { background: #4fa3ff; } .ppc-vb.lisa { background: #a66bff; }
  .ppc-vb:nth-child(1){height:10px;animation-delay:0s}.ppc-vb:nth-child(2){height:18px;animation-delay:.07s}.ppc-vb:nth-child(3){height:28px;animation-delay:.14s}.ppc-vb:nth-child(4){height:32px;animation-delay:.21s}.ppc-vb:nth-child(5){height:24px;animation-delay:.17s}.ppc-vb:nth-child(6){height:18px;animation-delay:.1s}.ppc-vb:nth-child(7){height:26px;animation-delay:.19s}.ppc-vb:nth-child(8){height:14px;animation-delay:.05s}.ppc-vb:nth-child(9){height:20px;animation-delay:.12s}
  @keyframes ppc-veq { from{transform:scaleY(.25);opacity:.4} to{transform:scaleY(1);opacity:1} }
  .ppc-vlabel { font-size: 11px; color: rgba(255,255,255,.3); letter-spacing: .05em; }
  .ppc-call-status { font-size: 12px; color: rgba(255,255,255,.5); text-align: center; }

  /* Input row */
  .ppc-input-row { padding: 0 14px 14px; display: flex; gap: 8px; align-items: center; }
  .ppc-input {
    flex: 1; background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.07);
    border-radius: 10px; padding: 8px 11px; font-size: 12px; color: rgba(255,255,255,.7);
    outline: none; font-family: inherit;
    transition: border-color .2s;
  }
  .ppc-input:focus { border-color: rgba(79,163,255,.3); }
  .ppc-input::placeholder { color: rgba(255,255,255,.2); }
  .ppc-send {
    width: 32px; height: 32px; border-radius: 50%; border: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
    transition: transform .15s;
  }
  .ppc-send:hover { transform: scale(1.1); }
  .ppc-send.amy { background: #4fa3ff; } .ppc-send.lisa { background: #a66bff; }
  .ppc-send svg { width: 14px; height: 14px; }

  /* Call button */
  .ppc-call-btn {
    width: 100%; border: none; border-radius: 10px; padding: 10px;
    font-size: 13px; font-weight: 500; cursor: pointer; font-family: inherit;
    display: flex; align-items: center; justify-content: center; gap: 7px;
    transition: opacity .2s;
  }
  .ppc-call-btn:hover { opacity: .85; }
  .ppc-call-btn.amy { background: #4fa3ff; color: #020d1a; }
  .ppc-call-btn.lisa { background: #a66bff; color: #0d0520; }
  .ppc-call-btn svg { width: 15px; height: 15px; }
  .ppc-call-wrap { padding: 0 14px 14px; }
  `;

  /* ── DOM Builder ─────────────────────────────────────────── */
  function inject() {
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    const wrap = document.createElement('div');
    wrap.id = 'ppc-widget-wrap';
    wrap.innerHTML = `
      <div id="ppc-tooltip">
        <div class="ppc-tip-orbs">
          <canvas class="ppc-tip-canvas" id="ppc-orb-atip" width="20" height="20"></canvas>
          <canvas class="ppc-tip-canvas" id="ppc-orb-ltip" width="20" height="20"></canvas>
        </div>
        <div class="ppc-tip-text">
          <strong>Amy &amp; Lisa are here</strong>
          <span>Sales &middot; Support</span>
        </div>
        <div id="ppc-tooltip-arrow"></div>
      </div>
      <div id="ppc-launcher" role="button" aria-label="Chat with Amy or Lisa" tabindex="0">
        <canvas id="ppc-orb-main" width="54" height="54"></canvas>
        <div class="ppc-ring"></div>
        <div class="ppc-ring2"></div>
        <div id="ppc-online"></div>
      </div>
    `;
    document.body.appendChild(wrap);

    /* Panel */
    const panel = document.createElement('div');
    panel.id = 'ppc-panel';
    panel.className = 'hidden';
    panel.innerHTML = buildPanel('amy');
    document.body.appendChild(panel);

    /* Orbs */
    makeOrb('ppc-orb-main', 54, '#4fa3ff','#76c8ff','#1a6fff', 1.0);
    makeOrb('ppc-orb-atip', 20, '#4fa3ff','#76c8ff','#1a6fff', 1.1);
    makeOrb('ppc-orb-ltip', 20, '#a66bff','#c49fff','#7b3fff', 1.1);

    /* Auto-dismiss tooltip */
    const tip = document.getElementById('ppc-tooltip');
    setTimeout(() => tip.classList.add('hidden'), 4000);

    /* Toggle panel on launcher click */
    document.getElementById('ppc-launcher').addEventListener('click', () => {
      panel.classList.toggle('hidden');
      tip.classList.add('hidden');
      if (!panel.classList.contains('hidden')) initPanelOrbs();
    });

    /* Close button */
    panel.addEventListener('click', e => {
      if (e.target.id === 'ppc-close') panel.classList.add('hidden');
    });

    /* Agent card selection */
    panel.addEventListener('click', e => {
      const card = e.target.closest('.ppc-agent-card');
      if (!card) return;
      const agent = card.dataset.agent;
      panel.innerHTML = buildAgentView(agent);
      initPanelOrbs();
      bindAgentView(agent);
    });

    /* Back to selection */
    panel.addEventListener('click', e => {
      if (e.target.closest('#ppc-back')) {
        panel.innerHTML = buildPanel('select');
        initPanelOrbs();
      }
    });
  }

  /* ── Panel HTML ──────────────────────────────────────────── */
  function buildPanel() {
    return `
      <div class="ppc-panel-header">
        <div>
          <div class="ppc-panel-title">Phoenix Phase Converters</div>
          <div class="ppc-panel-sub">AI assistant · online now</div>
        </div>
        <button id="ppc-close" aria-label="Close">✕</button>
      </div>
      <div class="ppc-agents">
        <div class="ppc-agent-card amy" data-agent="amy">
          <canvas id="ppc-orb-amy-card" width="48" height="48"></canvas>
          <div class="ppc-agent-name">Amy</div>
          <div class="ppc-agent-role">Sales &amp; pricing</div>
          <div class="ppc-agent-dot amy"></div>
        </div>
        <div class="ppc-agent-card lisa" data-agent="lisa">
          <canvas id="ppc-orb-lisa-card" width="48" height="48"></canvas>
          <div class="ppc-agent-name">Lisa</div>
          <div class="ppc-agent-role">Tech support</div>
          <div class="ppc-agent-dot lisa"></div>
        </div>
      </div>
    `;
  }

  function buildAgentView(agent) {
    const isAmy = agent === 'amy';
    const name  = isAmy ? 'Amy' : 'Lisa';
    const role  = isAmy ? 'Sales &amp; pricing' : 'Tech support';
    const col   = isAmy ? 'amy' : 'lisa';
    const intro = isAmy
      ? "Hi! I'm Amy. What motor horsepower are you running and what type of load is it?"
      : "Hey! Lisa here. Is your unit not starting, tripping, or running rough?";
    return `
      <div class="ppc-panel-header">
        <div style="display:flex;align-items:center;gap:10px">
          <button id="ppc-back" aria-label="Back" style="background:rgba(255,255,255,.07);border:none;color:rgba(255,255,255,.5);border-radius:50%;width:24px;height:24px;cursor:pointer;font-size:13px;display:flex;align-items:center;justify-content:center;">←</button>
          <canvas id="ppc-orb-agent-hdr" width="28" height="28" style="border-radius:50%"></canvas>
          <div>
            <div class="ppc-panel-title">${name}</div>
            <div class="ppc-panel-sub">${role}</div>
          </div>
        </div>
        <button id="ppc-close" aria-label="Close">✕</button>
      </div>
      <div class="ppc-tabs">
        <button class="ppc-tab active-${col}" id="ppc-tab-chat" data-mode="chat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          Chat
        </button>
        <button class="ppc-tab" id="ppc-tab-call" data-mode="call">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.38 2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.5a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          Call
        </button>
      </div>
      <div class="ppc-chat" id="ppc-chat-area">
        <div class="ppc-bubble agent-${col}">${intro}</div>
        <div class="ppc-typing ${col}" id="ppc-typing">
          <div class="ppc-td ${col}"></div><div class="ppc-td ${col}"></div><div class="ppc-td ${col}"></div>
        </div>
      </div>
      <div class="ppc-voice" id="ppc-voice-area">
        <div class="ppc-veq">
          ${Array(9).fill(`<div class="ppc-vb ${col}"></div>`).join('')}
        </div>
        <div class="ppc-vlabel" id="ppc-vlabel">${name} is ready…</div>
        <div class="ppc-call-wrap" style="width:100%">
          <button class="ppc-call-btn ${col}" id="ppc-call-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.38 2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.5a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            Start call with ${name}
          </button>
        </div>
      </div>
      <div class="ppc-input-row" id="ppc-input-row">
        <input class="ppc-input" id="ppc-input" placeholder="Type a message…" autocomplete="off" />
        <button class="ppc-send ${col}" id="ppc-send-btn" aria-label="Send">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        </button>
      </div>
    `;
  }

  /* ── Bind agent view events ──────────────────────────────── */
  function bindAgentView(agent) {
    const isAmy   = agent === 'amy';
    const col     = isAmy ? 'amy' : 'lisa';
    const agentId = isAmy ? AMY_AGENT_ID : LISA_AGENT_ID;
    const name    = isAmy ? 'Amy' : 'Lisa';
    let callActive = false;
    let retellClient = null;

    setTimeout(() => {
      const typing = document.getElementById('ppc-typing');
      if (typing) typing.style.display = 'none';
    }, 2000);

    /* Tab switching */
    document.getElementById('ppc-tab-chat')?.addEventListener('click', () => {
      document.getElementById('ppc-chat-area').style.display = 'flex';
      document.getElementById('ppc-voice-area').style.display = 'none';
      document.getElementById('ppc-input-row').style.display = 'flex';
      document.getElementById('ppc-tab-chat').className = `ppc-tab active-${col}`;
      document.getElementById('ppc-tab-call').className = 'ppc-tab';
    });

    document.getElementById('ppc-tab-call')?.addEventListener('click', () => {
      document.getElementById('ppc-chat-area').style.display = 'none';
      document.getElementById('ppc-voice-area').style.display = 'flex';
      document.getElementById('ppc-input-row').style.display = 'none';
      document.getElementById('ppc-tab-call').className = `ppc-tab active-${col}`;
      document.getElementById('ppc-tab-chat').className = 'ppc-tab';
    });

    /* Call button — Retell WebRTC */
    document.getElementById('ppc-call-btn')?.addEventListener('click', async () => {
      const btn = document.getElementById('ppc-call-btn');
      const lbl = document.getElementById('ppc-vlabel');
      if (callActive) {
        if (retellClient) retellClient.stopCall();
        callActive = false;
        btn.textContent = `Start call with ${name}`;
        lbl.textContent = `${name} is ready…`;
        return;
      }
      btn.textContent = 'Connecting…';
      lbl.textContent = 'Starting call…';
      try {
        const res = await fetch('https://api.retellai.com/v2/create-web-call', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${RETELL_KEY}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ agent_id: agentId })
        });
        const data = await res.json();
        const { RetellWebClient } = await import('https://cdn.jsdelivr.net/npm/retell-client-js-sdk@latest/+esm');
        retellClient = new RetellWebClient();
        await retellClient.startCall({ accessToken: data.access_token, sampleRate: 24000 });
        callActive = true;
        btn.textContent = 'End call';
        btn.style.background = '#e74c3c';
        lbl.textContent = `${name} is speaking…`;
        retellClient.on('call_ended', () => {
          callActive = false;
          btn.textContent = `Start call with ${name}`;
          btn.style.background = '';
          lbl.textContent = `${name} is ready…`;
        });
      } catch(err) {
        btn.textContent = `Start call with ${name}`;
        lbl.textContent = 'Connection failed — try again';
        console.error('[PPC Widget] Call error:', err);
      }
    });

    /* Chat send (stub — wire to your backend or Retell chat) */
    const sendMsg = () => {
      const input = document.getElementById('ppc-input');
      const chat  = document.getElementById('ppc-chat-area');
      const text  = input?.value?.trim();
      if (!text || !chat) return;
      const bubble = document.createElement('div');
      bubble.className = 'ppc-bubble user';
      bubble.textContent = text;
      chat.appendChild(bubble);
      input.value = '';
      const typing = document.createElement('div');
      typing.className = `ppc-typing ${col}`;
      typing.innerHTML = `<div class="ppc-td ${col}"></div><div class="ppc-td ${col}"></div><div class="ppc-td ${col}"></div>`;
      chat.appendChild(typing);
      chat.scrollTop = chat.scrollHeight;
      setTimeout(() => { typing.remove(); }, 2500);
    };
    document.getElementById('ppc-send-btn')?.addEventListener('click', sendMsg);
    document.getElementById('ppc-input')?.addEventListener('keydown', e => { if (e.key === 'Enter') sendMsg(); });
  }

  /* ── Init panel orbs after HTML swap ────────────────────── */
  function initPanelOrbs() {
    if (document.getElementById('ppc-orb-amy-card'))  makeOrb('ppc-orb-amy-card',  48, '#4fa3ff','#76c8ff','#1a6fff', 1.0);
    if (document.getElementById('ppc-orb-lisa-card')) makeOrb('ppc-orb-lisa-card', 48, '#a66bff','#c49fff','#7b3fff', 1.1);
    if (document.getElementById('ppc-orb-agent-hdr')) {
      const panel = document.getElementById('ppc-panel');
      const isAmy = panel?.innerHTML?.includes('agent-amy') || panel?.innerHTML?.includes('active-amy');
      makeOrb('ppc-orb-agent-hdr', 28, isAmy ? '#4fa3ff' : '#a66bff', isAmy ? '#76c8ff' : '#c49fff', isAmy ? '#1a6fff' : '#7b3fff', 1.1);
    }
  }

  /* ── Canvas orb renderer ─────────────────────────────────── */
  function makeOrb(id, W, c1, c2, c3, spd) {
    const cv = document.getElementById(id);
    if (!cv) return;
    cv.width = W; cv.height = W;
    const ctx = cv.getContext('2d');
    const CX = W/2, CY = W/2, R = W/2 - 1;
    const N = W > 30 ? 16 : 8;
    const streams = [];
    for (let s = 0; s < N; s++) {
      const segs = [];
      const base = Math.random() * Math.PI * 2, tilt = Math.random() * Math.PI;
      const pts = W > 30 ? 30 : 16;
      for (let p = 0; p < pts; p++) segs.push({ a: base + p * 0.17, b: tilt + Math.sin(p * 0.27) * 0.5 });
      streams.push({ segs, off: Math.random() * 200, spd: 0.004 + Math.random() * 0.005 * spd, w: W > 30 ? 0.6 + Math.random() * .8 : 0.35 + Math.random() * .4 });
    }
    let t = 0;
    const frame = () => {
      if (!document.getElementById(id)) return;
      ctx.clearRect(0, 0, W, W);
      ctx.save();
      ctx.beginPath(); ctx.arc(CX, CY, R, 0, Math.PI * 2); ctx.clip();
      const bg = ctx.createRadialGradient(CX, CY, 0, CX, CY, R);
      bg.addColorStop(0, c1 + '30'); bg.addColorStop(0.55, c2 + '18'); bg.addColorStop(1, '#000');
      ctx.fillStyle = bg; ctx.fillRect(0, 0, W, W);
      streams.forEach((st, si) => {
        const ph = t * st.spd + st.off;
        ctx.beginPath(); let first = true;
        st.segs.forEach((p, pi) => {
          const a = p.a + ph * .65, b = p.b + Math.sin(ph + pi * .19) * .32;
          const sa = Math.sin(a), ca = Math.cos(a), sb = Math.sin(b), cb = Math.cos(b);
          const rz = R * ca, sc = 1 + (rz / R) * .14;
          const sx = CX + R * sa * cb * sc, sy = CY + R * sa * sb * sc;
          if (first) { ctx.moveTo(sx, sy); first = false; } else ctx.lineTo(sx, sy);
        });
        const al = (0.28 + Math.sin(ph * 1.4 + si) * .2) * .85;
        const col = si % 3 === 0 ? c1 : si % 3 === 1 ? c2 : c3;
        ctx.strokeStyle = col + Math.floor(al * 255).toString(16).padStart(2, '0');
        ctx.lineWidth = st.w; ctx.stroke();
      });
      const rim = ctx.createRadialGradient(CX, CY, R * .7, CX, CY, R);
      rim.addColorStop(0, 'transparent'); rim.addColorStop(1, c1 + '38');
      ctx.fillStyle = rim; ctx.fillRect(0, 0, W, W);
      ctx.restore();
      t++; requestAnimationFrame(frame);
    };
    frame();
  }

  /* ── Boot ────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
